export default class {
  constructor ({label, url, method, payload}) {
    this.label = label
    this.url = url
    this.method = method
    this.payload = payload
  }
}



// WEBPACK FOOTER //
// ./src/domain/Action.js